// extracted by mini-css-extract-plugin
export default {"addEvent":"AddNewEventButton_addEvent__cZkfH"};